/**
 * @generated SignedSource<<e0661a806a9a0eb82c397daaa604198e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference";
};
export type hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference$key = {
  readonly " $data"?: hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "hubEditMode"
    }
  ],
  "kind": "Fragment",
  "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference",
  "selections": [
    {
      "condition": "hubEditMode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "cloudIds.0",
                  "variableName": "cloudId"
                }
              ],
              "kind": "ListValue",
              "name": "cloudIds"
            }
          ],
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "cloudUrl"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "951df66590a0cca5f7516d267ed12179";

export default node;
